import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@saleor/components/Checkbox";
import ConfirmButton, {
  ConfirmButtonTransitionState
} from "@saleor/components/ConfirmButton";
import Form from "@saleor/components/Form";
import FormSpacer from "@saleor/components/FormSpacer";
import Hr from "@saleor/components/Hr";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import useSearchQuery from "@saleor/hooks/useSearchQuery";
import { buttonMessages } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { SearchStores_search_edges_node } from "@saleor/searches/types/SearchStores";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
interface FormData {
  allStores: boolean;
  stores: string[];
}

export interface AssignStoreSelectDialogProps {
  confirmButtonState: ConfirmButtonTransitionState;
  stores: SearchStores_search_edges_node[];
  initial: any;
  open: boolean;
  onClose: () => void;
  onFetch: (value: string) => void;
  onConfirm: (data: FormData) => void;
}

const useStyles = makeStyles(
  theme => ({
    checkboxCell: {
      paddingLeft: 0
    },
    container: {
      maxHeight: 500
    },
    heading: {
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(2)
    },
    wideCell: {
      width: "100%"
    }
  }),
  { name: "AssignStoreSelectDialog" }
);
const AssignStoreSelectDialog: React.FC<AssignStoreSelectDialogProps> = props => {
  const {
    confirmButtonState,
    onClose,
    stores,
    open,
    initial,
    onFetch,
    onConfirm
  } = props;
  const classes = useStyles(props);

  const intl = useIntl();

  const initialValue = maybe(() => initial.map(({ node }) => node.id));
  const initialForm: FormData = {
    allStores: true,
    stores: initialValue
  };

  const [query, onQueryChange] = useSearchQuery(onFetch);
  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth="sm">
      <Form initial={initialForm} onSubmit={onConfirm}>
        {({ data, change }) => {
          const storeSelection = stores.reduce((acc, store) => {
            acc[store.id] = !!data.stores.find(
              selectedstores => selectedstores === store?.id
            );
            return acc;
          }, {});

          return (
            <>
              <DialogTitle>
                <FormattedMessage
                  defaultMessage="Assign stores"
                  description="dialog header"
                />
              </DialogTitle>
              <DialogContent>
                <Typography>
                  <FormattedMessage defaultMessage="Choose stores, you want sale to be limited to, from the list below" />
                </Typography>
                <FormSpacer />
                <TextField
                  name="query"
                  value={query}
                  onChange={onQueryChange}
                  label={intl.formatMessage({
                    defaultMessage: "Filter stores",
                    description: "search box label"
                  })}
                  id={`filterStoreTxt`}
                  placeholder={intl.formatMessage({
                    defaultMessage: "Search by mall name",
                    description: "search box placeholder"
                  })}
                  fullWidth
                />
              </DialogContent>
              <Hr />
              <DialogContent className={classes.container}>
                <Typography className={classes.heading} variant="subtitle1">
                  <FormattedMessage
                    defaultMessage="Stores A to Z"
                    description="mall selection"
                  />
                </Typography>
                <ResponsiveTable>
                  <TableBody>
                    {stores &&
                      stores.map((store, index) => {
                        const isChecked = storeSelection[store.id];

                        return (
                          <TableRow key={store.id}>
                            <TableCell
                              className={classes.wideCell}
                              id={`storeNameRow${index}`}
                            >
                              {store.storeName}
                            </TableCell>
                            <TableCell
                              padding="checkbox"
                              className={classes.checkboxCell}
                            >
                              <Checkbox
                                id={`storeCheckboxRow${index}`}
                                checked={isChecked}
                                onChange={() =>
                                  isChecked
                                    ? change({
                                        target: {
                                          name: "stores" as keyof FormData,
                                          value: data.stores.filter(
                                            selectedstores =>
                                              selectedstores !== store.id
                                          )
                                        }
                                      } as any)
                                    : change({
                                        target: {
                                          name: "stores" as keyof FormData,
                                          value: [...data.stores, store.id]
                                        }
                                      } as any)
                                }
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </ResponsiveTable>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} id="backBtn">
                  <FormattedMessage {...buttonMessages.back} />
                </Button>
                <ConfirmButton
                  id="assignStoresBtn"
                  transitionState={confirmButtonState}
                  color="primary"
                  variant="contained"
                  type="submit"
                >
                  <FormattedMessage
                    defaultMessage="Assign stores"
                    description="button"
                  />
                </ConfirmButton>
              </DialogActions>
            </>
          );
        }}
      </Form>
    </Dialog>
  );
};
AssignStoreSelectDialog.displayName = "AssignStoreSelectDialog";
export default AssignStoreSelectDialog;
